interface SentimentIndicatorProps {
  sentiment: number;
}

export const SentimentIndicator = ({ sentiment }: SentimentIndicatorProps) => {
  return (
    <div className="mt-3 flex items-center border-t border-card-border pt-3">
      <span className="mr-2 text-xs text-muted-foreground">Feeling:</span>
      <div className="flex space-x-1">
        {[1, 2, 3, 4, 5].map((rating) => (
          <div
            key={rating}
            className={`h-2 w-2 rounded-full ${rating <= sentiment ? "bg-primary" : "bg-muted"}`}
          />
        ))}
      </div>
    </div>
  );
};
